import { action } from "typesafe-actions";
import { TrustlyInfo } from "types";

export const PROVIDER_INFO = "PROVIDER_INFO";

export const setProviderInfo = (payload: TrustlyInfo) =>
  action(PROVIDER_INFO, payload);
